import { render, staticRenderFns } from "./setting-sms.vue?vue&type=template&id=b10c686e&scoped=true&"
import script from "./setting-sms.vue?vue&type=script&lang=js&"
export * from "./setting-sms.vue?vue&type=script&lang=js&"
import style0 from "./setting-sms.vue?vue&type=style&index=0&id=b10c686e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10c686e",
  null
  
)

export default component.exports